/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// 日期格式化
export function parseTime(time, pattern) {
    if (!time) {
        return ""
    }
    time = new Date(time)
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}

// 获取文件后缀名
export function getFileExtension(fileName) {
    console.log(fileName);

    // 使用 lastIndexOf 和 substring 方法
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === 0) {
        return ''; // 没有扩展名或文件名以点开头
    }

    return fileName.substring(lastDotIndex + 1);
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
    let search = params;
    search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
    dateRange = Array.isArray(dateRange) ? dateRange : [];
    if (typeof (propName) === 'undefined') {
        search.params['beginTime'] = dateRange[0];
        search.params['endTime'] = dateRange[1];
    } else {
        search.params['begin' + propName] = dateRange[0];
        search.params['end' + propName] = dateRange[1];
    }
    return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    if (value === undefined) {
        return "";
    }
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].value == ('' + value)) {
            actions.push(datas[key].label);
            return true;
        }
    })
    if (actions.length === 0) {
        actions.push(value);
    }
    return actions.join('');
}

// 回显数据字典（字符串、数组）
export function selectDictLabels(datas, value, separator) {
    if (value === undefined || value.length === 0) {
        return "";
    }
    if (Array.isArray(value)) {
        value = value.join(",");
    }
    var actions = [];
    var currentSeparator = undefined === separator ? "," : separator;
    var temp = value.split(currentSeparator);
    Object.keys(value.split(currentSeparator)).some((val) => {
        var match = false;
        Object.keys(datas).some((key) => {
            if (datas[key].value == ('' + temp[val])) {
                actions.push(datas[key].label + currentSeparator);
                match = true;
            }
        })
        if (!match) {
            actions.push(temp[val] + currentSeparator);
        }
    })
    return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
    var args = arguments, flag = true, i = 1;
    str = str.replace(/%s/g, function () {
        var arg = args[i++];
        if (typeof arg === 'undefined') {
            flag = false;
            return '';
        }
        return arg;
    });
    return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
    if (!str || str == "undefined" || str == "null") {
        return "";
    }
    return str;
}

// 数据合并
export function mergeRecursive(source, target) {
    for (var p in target) {
        try {
            if (target[p].constructor == Object) {
                source[p] = mergeRecursive(source[p], target[p]);
            } else {
                source[p] = target[p];
            }
        } catch (e) {
            source[p] = target[p];
        }
    }
    return source;
};

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
    };

    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }

    return tree;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
    let result = ''
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && value !== "" && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        result += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + "&";
            }
        }
    }
    return result
}

// 验证是否为blob格式
export function blobValidate(data) {
    return data.type !== 'application/json'
}

/**
 * 金额转换千分位
 * @param {*} money 金额
 */
export function formatMoney(money) {
    // if (!money) return '0.00'
    // let integer = Math.floor(money).toString()
    // console.log('money --',money)
    // let decimal = (money - integer).toFixed(2).slice(2)
    // console.log('decimal --',decimal)
    //
    // let thousands = integer.split('').reverse().join('').replace(/(\d{3})/g, '$1,').replace(/,$/, '')
    // return thousands.split('').reverse().join('') + '.' + decimal


    // 转换为数字，确保输入有效
    let num = parseFloat(money);
    if (isNaN(num)) {
        throw new Error("输入的金额无效");
    }

    // 保留四位小数
    num = num.toFixed(2);

    // 分离整数部分和小数部分
    let [integerPart, decimalPart] = num.split('.');

    // 使用正则表达式将整数部分格式化为千分位
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // 拼接整数部分和小数部分
    return `${integerPart}.${decimalPart}`;
}

// 转换金额为大写
export function convertCurrency(money) {
    //汉字的数字
    const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    //基本单位
    const cnIntRadice = ['', '拾', '佰', '仟'];
    //对应整数部分扩展单位
    const cnIntUnits = ['', '万', '亿', '兆'];
    //对应小数部分单位
    const cnDecUnits = ['角', '分', '毫', '厘'];
    //整数金额时后面跟的字符
    const cnInteger = '整';
    //整型完以后的单位
    const cnIntLast = '元';
    //最大处理的数字
    let maxNum = 999999999999999.9999;
    //金额整数部分
    let integerNum;
    //金额小数部分
    let decimalNum;
    //输出的中文金额字符串
    let chineseStr = '';
    //分离金额后用的数组，预定义
    let parts;
    if (money === '') {
        return '';
    }
    money = parseFloat(money);
    if (money >= maxNum) {
        //超出最大处理数字
        return '';
    }
    if (money === 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
    }
    //转换为字符串
    money = money.toString();
    if (money.indexOf('-') === 0) {
        chineseStr = chineseStr + '负'
        money = money.substr(1)
    }
    if (money.indexOf('.') === -1) {
        integerNum = money;
        decimalNum = '';
    } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1);
            let p = IntLen - i - 1;
            let q = p / 4;
            let m = p % 4;
            if (n == '0') {
                zeroCount++;
            } else {
                if (zeroCount > 0) {
                    chineseStr += cnNums[0];
                }
                //归零
                zeroCount = 0;
                chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
            }
            if (m == 0 && zeroCount < 4) {
                chineseStr += cnIntUnits[q];
            }
        }
        chineseStr += cnIntLast;
    }
    //小数部分
    if (decimalNum !== '') {
        let decLen = decimalNum.length;
        for (let i = 0; i < decLen; i++) {
            let n = decimalNum.substr(i, 1);
            if (n !== '0') {
                chineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
        }
    }
    if (chineseStr === '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum === '') {
        chineseStr += cnInteger;
    }
    return chineseStr;
}


export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj))
}

export function getRelaveFormDataByInstanceId(processInstanceId,destGroupId) {
    return request({
        url: '/flow/instance/getRelaveFormDataByInstanceId?processInstanceId='+processInstanceId+'&destGroupId='+destGroupId,
        method: 'get'
    });
}
//校验规则：16位银行卡号（19位通用）:
// 1.将未带校验位的 15（或18）位卡号从右依次编号 1 到 15（18），位于奇数位号上的数字乘以 2。
// 2.将奇位乘积的个十位全部相加，再加上所有偶数位上的数字。
// 3.将加法和加上校验位能被 10 整除。
export function checkBankCardNum(bankno){
    let lastNum=bankno.substr(bankno.length-1,1);//取出最后一位

    let first15Num=bankno.substr(0,bankno.length-1);//前15或18位
    let newArr=new Array();
    for(let i=first15Num.length-1;i>-1;i--){    //前15或18位倒序存进数组
        newArr.push(first15Num.substr(i,1));
    }
    let arrJiShu=new Array();  //奇数位*2的积 <9
    let arrJiShu2=new Array(); //奇数位*2的积 >9

    let arrOuShu=new Array();  //偶数位数组
    for(let j=0;j<newArr.length;j++){
        if((j+1)%2==1){//奇数位
            if(parseInt(newArr[j])*2<9)
                arrJiShu.push(parseInt(newArr[j])*2);
            else
                arrJiShu2.push(parseInt(newArr[j])*2);
        }
        else //偶数位
            arrOuShu.push(newArr[j]);
    }

    let jishu_child1=new Array();//奇数位*2 >9 的分割之后的数组个位数
    let jishu_child2=new Array();//奇数位*2 >9 的分割之后的数组十位数
    for(let h=0;h<arrJiShu2.length;h++){
        jishu_child1.push(parseInt(arrJiShu2[h])%10);
        jishu_child2.push(parseInt(arrJiShu2[h])/10);
    }

    let sumJiShu=0; //奇数位*2 < 9 的数组之和
    let sumOuShu=0; //偶数位数组之和
    let sumJiShuChild1=0; //奇数位*2 >9 的分割之后的数组个位数之和
    let sumJiShuChild2=0; //奇数位*2 >9 的分割之后的数组十位数之和
    let sumTotal=0;
    for(let m=0;m<arrJiShu.length;m++){
        sumJiShu=sumJiShu+parseInt(arrJiShu[m]);
    }

    for(let n=0;n<arrOuShu.length;n++){
        sumOuShu=sumOuShu+parseInt(arrOuShu[n]);
    }

    for(let p=0;p<jishu_child1.length;p++){
        sumJiShuChild1=sumJiShuChild1+parseInt(jishu_child1[p]);
        sumJiShuChild2=sumJiShuChild2+parseInt(jishu_child2[p]);
    }
    //计算总和
    sumTotal=parseInt(sumJiShu)+parseInt(sumOuShu)+parseInt(sumJiShuChild1)+parseInt(sumJiShuChild2);

    //计算Luhm值
    let k= parseInt(sumTotal)%10==0?10:parseInt(sumTotal)%10;
    let luhm= 10-k;

    if(lastNum==luhm){
        return null;
    }
    else{
        return "账号非法，请确认该账号的真实性！";
    }
}

export function checkBankCardNo(t_bankno) {
    let bankno =t_bankno.replace(/\s+/g, '')
    console.log('bankno====',bankno)
    if (bankno == "") {
        return "账号为空！";
    }
    if (bankno.length < 16 || bankno.length > 19) {
        return "账号长度必须在16到19之间！";
    }
    let num = /^\d*$/;  //全数字
    if (!num.exec(bankno)) {
        return "账号必须全为数字！";
    }
    //开头6位
    let strBin="10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99";
    if (strBin.indexOf(bankno.substring(0, 2))== -1) {
        return "账号开头6位不符合规范！";
    }
    let result = checkBankCardNum(bankno)
    return result;
}
export function checkBaseBankCardNo(t_bankno) {
    let bankno =t_bankno.replace(/\s+/g, '')
    console.log('bankno====',bankno)
    if (bankno == "") {
        return "账号为空！";
    }
    let num = /^\d*$/;  //全数字
    if (!num.exec(bankno)) {
        return "账号必须全为数字！";
    }
    let result = containsChinese(bankno)
    return result;
}
export function containsChinese(str) {
    for (let char of str) {
        if (/[\u4e00-\u9fff\u3400-\u4dbf]/.test(char)) {
            return "账号非法，请确认该账号的真实性！";
        }
    }
    return null;
}

export function compareJson(newData, oldData) {
    let result = []
    for (let key in newData) {
        if (typeof newData[key] === '[object Array]') {
            if(oldData[key]){
                console.log(JSON.stringify(newData[key]))
                console.log(JSON.stringify(oldData[key]))
                if(JSON.stringify(oldData[key]) !== JSON.stringify(newData[key])){
                    result.push(key)
                }
            }else{
                result.push(key)
            }
        }else if (typeof newData[key] === 'object') {
            if(oldData[key]){
                console.log(JSON.stringify(newData[key]))
                console.log(JSON.stringify(oldData[key]))
                if(JSON.stringify(oldData[key]) !== JSON.stringify(newData[key])){
                    result.push(key)
                }
            }else{
                result.push(key)
            }
        }else if (newData[key] != oldData[key]) {
            result.push(key)
        }
    }
    return result;
}

export function formatToTwoDecimals(item, field) { // 保留两位小数
    const value = parseFloat(item[field]);
    if (!isNaN(value)) {
        item[field] = value.toFixed(2);
    }
}
